export default __webpack_public_path__ + "static/media/boxBG.2515f761.jpg";